import { EBuildingType } from '../../../../json_query';
import { ensureSingleTagExists } from '../helpers';
import { ITagDefinition, TTag } from '../index';

const IBuildingTypeTagType = 'advanced-buildingType';

export interface IBuildingTypeTag {
  type: 'advanced-buildingType';
  value: EBuildingType;
}

const isBuildingTypeTag = (tag: TTag): tag is IBuildingTypeTag => tag.type === IBuildingTypeTagType;

export const buildingTypeTagDefinition: ITagDefinition = {
  reduce: (tags, jsonQuery) => {
    const values = jsonQuery.building_type2 && jsonQuery.building_type2.value;

    let nextTags = tags.filter(
      tag => tag.type !== IBuildingTypeTagType || (values && values.some(value => value === tag.value)),
    );

    if (values !== undefined) {
      nextTags = values.reduce(
        (result, value: EBuildingType) =>
          ensureSingleTagExists(
            result,
            (tag: TTag): tag is IBuildingTypeTag => isBuildingTypeTag(tag) && tag.value === value,
            previousTag => ({ type: IBuildingTypeTagType, value }),
          ),
        nextTags,
      );
    }

    return nextTags;
  },
};
